import { useSyncExternalStore } from "react";
import { statusStore } from "./statusStore";

export const useStatusStore = () => {
  const state = useSyncExternalStore(statusStore.subscribe, () => statusStore.state);
  return state;
};
